import { shallowRef } from 'vue'
import { storeToRefs } from 'pinia'
import { checkUsb3 } from '@/composables/useUsbSpeedCheck'
import { useDeviceStore } from '@/stores'

export function useKeyboardReportRate16kGuard() {
  const deviceStore = useDeviceStore()
  const { currentDevice } = storeToRefs(deviceStore)

  const isChecking = shallowRef(false)
  const isUsb2DialogOpen = shallowRef(false)
  const isUsb3DialogOpen = shallowRef(false)

  async function open16kDriverDownload() {
    const device = currentDevice.value
    if (!device) return
    const firmware = device.features.firmware
    if (!firmware) return
    const SIXTEEN_K_DRIVER_DOWNLOAD_URL =
      await firmware.getFirmwareAttachmentUrl('ReportRate16KURL')
    if (!SIXTEEN_K_DRIVER_DOWNLOAD_URL) return
    window.open(SIXTEEN_K_DRIVER_DOWNLOAD_URL, '_blank', 'noopener,noreferrer')
  }

  /**
   * 点击 16K 时校验 USB 版本与 16K 驱动。
   * 仅 USB 3.0 且已安装驱动时允许切换；否则弹出对应提示。
   * 配置页强制提醒：不受进入设备「不再显示」偏好影响。
   */
  async function canSwitchTo16k(): Promise<boolean> {
    const device = currentDevice.value
    if (!device || isChecking.value) return false

    isChecking.value = true
    try {
      const result = await checkUsb3(device)
      if (result.isUsb3 === true && result.has16kDriver) {
        return true
      }
      if (result.isUsb3 === true) {
        isUsb3DialogOpen.value = true
        return false
      }
      isUsb2DialogOpen.value = true
      return false
    } finally {
      isChecking.value = false
    }
  }

  return {
    isChecking,
    isUsb2DialogOpen,
    isUsb3DialogOpen,
    canSwitchTo16k,
    open16kDriverDownload,
  }
}
